<template>
  <div>
    <v-dialog fullscreen :value="showDialog" v-if="showDialog" persistent>
      <v-card class="login-iframe-wrapper">
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
          v-if="isLoadingSelfDetails"
        />
        <iframe
          title="login"
          v-else
          ref="iframe"
          frameBorder="0"
          :src="iframeSrc"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { GET_AUTH_DIALOG_VISIBILITY_STATUS } from "@/store/modules/global/getters";
import { SET_AUTH_DIALOG_VISIBILITY } from "@/store/modules/global/mutation-types";
import { FETCH_SELF_DETAILS } from "@/store/modules/auth/action-types";
import { mapMutations, mapGetters } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import isJSON from "is-json";
import { getToken } from "@/services/utils";
import { includes, some } from "lodash";

const LINK_ROUTES = ["self-schedule", "profile"];

const { mapActions: mapAuthActions, mapState } = createNamespacedHelpers(
  AUTH_NAMESPACE
);

export default {
  name: "LoginDialog",
  props: {
    isOpen: Boolean
  },
  created() {
    window.addEventListener("message", this.onMessage);
    document.title = this.showDialog ? "Login - Track" : "Track";
  },
  data() {
    return {
      iframeSrc: `${process.env.VUE_APP_AUTH_URL}/login`
    };
  },
  computed: {
    ...mapState({
      isLoadingSelfDetails: state => state.isLoadingSelfDetails
    }),
    ...mapGetters({
      showDialog: GET_AUTH_DIALOG_VISIBILITY_STATUS
    })
  },
  methods: {
    ...mapAuthActions({
      fetchSelf: FETCH_SELF_DETAILS
    }),
    ...mapMutations({
      setDialogVisibility: SET_AUTH_DIALOG_VISIBILITY
    }),
    shouldNavigateToPendingPath() {
      const userClickedEmailLink = some(LINK_ROUTES, route =>
        includes(this.$router.history.pending.fullPath, route)
      );
      return userClickedEmailLink;
    },
    async adjustUserData({ isNewUser }) {
      await this.fetchSelf();
      this.setDialogVisibility(false);
      let path = "/";
      if (
        this.$router.history.pending &&
        (!isNewUser || this.shouldNavigateToPendingPath())
      ) {
        path = this.$router.history.pending.fullPath;
      }

      this.$router.replace(path);
    },
    onMessage({ data: message }) {
      const isNewUser = !getToken();
      if (isJSON(message)) {
        const { token } = JSON.parse(message);
        if (token) {
          localStorage.setItem("token", token);
          this.adjustUserData({ isNewUser });
        }
      }
    }
  }
};
</script>

<style lang="scss"></style>
